import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import GiftAdd from "./GiftAdd";
import GiftEdit from "./GiftEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Purchase() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(0);
  const [tcid, setTcid] = useState('');
  const [names, setNameS] = useState('');
  const [phones, setPhoneS] = useState('');
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const title = '사은품신청';
  const token = localStorage.getItem("token");

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록", width: 140, align: "center" },
    { field: "state", headerName: "상태", width: 90, align: "center" },
    {
      field: "pdate", headerName: "발송일", align: "center",
      renderCell: (params) => {
        return <Box>{params.row.state === '발송' ? params.row.pdate : ''}</Box>
      }
    },
    {
      field: "mname",
      headerName: "고객명",
      width: 110,
      align: "center"
    },
    {
      field: "mphone",
      headerName: "연락처",
      width: 110,
      align: "center"
    },
    {
      field: "gid",
      headerName: "프리퀀시",
      width: 100,
      align: "center"
    },
    {
      field: "gname",
      headerName: "사은품",
      width: 200
    },
    {
      field: "opt",
      headerName: "옵션",
      width: 120
    },
    {
      field: "cname",
      headerName: "센터명",
      width: 300
    },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  // 리스트
  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/gift", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      names: names,
      phones: phones
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded) {
      load_data();
    }
  }, [loaded]);

  const onSearchClick = async () => {
    load_data();
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            {title}관리
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            {/* 센터명 */}
            <Box sx={{ flexGrow: 1 }}></Box>

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setOpenAdd(true)}
            >
              {title}내역 추가
            </Button>
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>

            <Box marginRight={1}>
              <CenterSelect
                login={login}
                tcidParent={tcid}
                setTcidParent={setTcid}
              />
            </Box>

            {/* 이름 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="names"
                label="이름"
                size="small"
                onChange={(e) => setNameS(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="phones"
                label="연락처"
                size="small"
                onChange={(e) => setPhoneS(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>
            <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              setOpenEdit(true);
            }}
          />

          {/* 추가팝업 */}
          <GiftAdd open={openAdd} setOpen={setOpenAdd} login={login} load_data={load_data}></GiftAdd>

          {/* 수정팝업 */}
          <GiftEdit openEdit={openEdit} setOpenEdit={setOpenEdit} login={login} load_data={load_data} seq={seq}></GiftEdit>

        </Layout>
      )}
    </>
  );
}

export default Purchase;
